import { FC } from 'react'

import DescriptionIcon from './assets/description-icon.svg'
import styles from './NameValue.pcss'

interface Props {
	name: React.ReactNode
	value: React.ReactNode
	description?: string
}

const NameValue: FC<Props> = ({ name, value, description }) => (
	<div className={styles.root}>
		<span className={styles.name}>
			{name}
			{description && <DescriptionIcon className={styles.description} />}
		</span>
		<span className={styles.value}>{value}</span>
	</div>
)

export default NameValue
